export default "__VITE_ASSET__127b5ce3__"